/* @flow */

import * as React from 'react';
import { Component } from 'react';
import PropTypes from 'prop-types';

export type ServiceBarProps = {
  /** Is the customer a wealth customer (true) or a personal customer (false) */
  wealthCustomer?: boolean,
  /** Show the Call us button true/false */
  showCallUs?: boolean,
  /** Show the Chat button true/false */
  showChat?: boolean,
  /** Show the Book meeting button true/false */
  showBookMeeting?: boolean,
  /** The phonenumber shown when clicking the Call us button */
  callUsPhoneNumberText?: string,
  /** Text shown for wealth customers */
  callUsCallPrivatBanker?: string,
  /** Heading on the Call us panel */
  callUsPanelHeader?: string,
  /** Opening hours */
  callUsOpeningHours?: React.Node,
  /** Information on the Call us panel */
  callUsInformation?: string,
  /** Label on the Call us button */
  callUsButtonLabel?: string,
  /** Label on the Chat button */
  chatButtonLabel?: string,
  /** Link that opens in a new window when clicking the Chat button */
  chatButtonLink?: string,
  /** Label on the Book meeting button */
  bookMeetingButtonLabel?: string,
  /** Link that opens in a new window when clicking the Book meeting button */
  bookMeetingButtonLink?: string,
};

type Props = {
  ...ServiceBarProps,
  children: React.Node,
};

// $FlowFixMe
export const ServiceBarContext: Context = React.createContext();

export default class ServiceBarProvider extends Component<Props> {
  render() {
    const { children, ...rest } = this.props;

    return (
      <ServiceBarContext.Provider value={rest}>
        {children}
      </ServiceBarContext.Provider>
    );
  }
}

export const ServiceBarPropTypes = {
  wealthCustomer: PropTypes.bool,
  showCallUs: PropTypes.bool,
  showChat: PropTypes.bool,
  showBookMeeting: PropTypes.bool,
  callUsPhoneNumberText: PropTypes.string,
  callUsCallPrivatBanker: PropTypes.string,
  callUsPanelHeader: PropTypes.string,
  callUsOpeningHours: PropTypes.node,
  callUsInformation: PropTypes.string,
  callUsButtonLabel: PropTypes.string,
  chatButtonLabel: PropTypes.string,
  chatButtonLink: PropTypes.string,
  bookMeetingButtonLabel: PropTypes.string,
  bookMeetingButtonLink: PropTypes.string,
};
